import type React from "react"

interface ProgressBarProps {
  percentage: number
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ percentage }) => {
  const clamped = Math.min(100, Math.max(0, percentage))
  return (
    <div className="relative h-[2px] w-full bg-[var(--color-line)]">
      <div className="bg-nelo-blue h-full transition-all duration-300 ease-in-out" style={{ width: `${clamped}%` }} />
      <div
        className="bg-nelo-blue absolute top-1/2 z-10 h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full transition-all duration-300 ease-in-out"
        style={{ left: `${clamped}%` }}
      />
    </div>
  )
}
